import * as consts from '../data/base/consts'

/**
 * 一些公共的方法
 */
import { LS } from './ls'
import { UA } from './ua'
import { FORM } from './form'
import { SCHEME } from './scheme'
import { COOKIE } from './cookie'
import { MOMENT_TIME } from '../momenttime'
import { CONFIG } from '../config'
import { MIX } from './mix'

var UTILS = {
    // 强制补齐两位小数点
    toDecimal2(x) { 
        var f = parseFloat(x); 
        if (isNaN(f)) { 
            return false; 
        } 
        var f = Math.round(x*100)/100; 
        var s = f.toString(); 
        var rs = s.indexOf('.'); 
        if (rs < 0) { 
            rs = s.length; 
            s += '.'; 
        } 
        while (s.length <= rs + 2) { 
            s += '0'; 
        } 
        return s; 
    },
    // 获取时间格式
    getTimeStrByInt(num) {
        num = !num ? 0 : parseInt(num);
        return num < 10 ? ('0' + num) : num;
    },
    // 获取节气的时间格式
    getTimeStrByArr(arr) {
        var result = '';
            result = result + UTILS.getTimeStrByInt(arr[1]) + '月';
            result = result + UTILS.getTimeStrByInt(arr[2]) + '日 ';
            result = result + UTILS.getTimeStrByInt(arr[3]) + ':';
            result = result + UTILS.getTimeStrByInt(arr[4]);
        return result;
    },
    // 获取倒计时时间4分59秒
    getTimeStrBySecond(second) {
        var mi = parseInt(second/60),
            ss = parseInt(second%60);
        return mi+'分'+ss+'秒';
    },
    // 获取倒计时时间04:59
    getTimeNumberStrBySecond(second) {
        var mi = parseInt(second/60),
            ss = parseInt(second%60);
        return (mi < 10 ? '0'+mi : mi)+':'+(ss < 10 ? '0'+ss : ss);
    },
    // 获取倒计时时间[04, 59]
    getTimeArrBySecond(second) {
        var mi = parseInt(second/60),
            ss = parseInt(second%60);
        var arr = [];
            arr.push(UTILS.getTimeStrByInt(mi));
            arr.push(UTILS.getTimeStrByInt(ss));
        return arr;
    },

    /**
     * 根据时间戳获取格式化的时间字符串
     * 年月日时分
     * @param {时间戳} timeStamp 
     * @returns {年-月-日}
     */
    getChineseTimeYMDHmByTimeStamp(timeStamp) {
        let timeStr = MOMENT_TIME.getFormateTimeYMDHmByTimeStamp(timeStamp*1000);
        timeStr = timeStr.replace('-', '年');
        timeStr = timeStr.replace('-', '月');
        timeStr = timeStr.replace(' ', '日');
        return timeStr;
    },

    /**
     * 
     * @param {时间戳} timeStamp 
     * @returns {月.日}
     */
    getMonthDayByTimeStamp(timeStamp) {
        let timeArr = MOMENT_TIME.getTimeArrayByTimeStamp(timeStamp*1000);
        return timeArr[1]+'.'+timeArr[2];
    },

    // 获取星期几的时间格式
    getWeekStrByInt(num) {
        var str = '星期';
        if(num == 0){
            str += '日';
        }else {
            str += consts.CONST_YEAR_WORD[num];
        }
        return str;
    },
    // 根据数组获取 yy-mm-dd hh:mm:ss 格式的时间
    getYmdHmsTimeStrByArr(arr) {
        var timeStr = '';
        for(var i = 0; i < 6; i++){
            timeStr += this.getTimeStrByInt(arr[i]);
            if(i < 2){
                timeStr += '-';
            }else if (i == 2){
                timeStr += ' ';
            }else if (i == 3 || i == 4){
                timeStr += ':';
            }
        }
        return timeStr;
    },
    // 根据数组获取 大运开始日期string 
    getDaYunStartTimeStrByData(data) {
        var str = data.y + '年';
            str = str + this.getTimeStrByInt(data.m) + '月';
            str = str + this.getTimeStrByInt(data.d) + '日';
            str = str + this.getTimeStrByInt(data.h) + '时';
            str = str + this.getTimeStrByInt(data.i) + '分交大运';
        return str;
    },
    // 根据数组获取 节气时间
    getJieQiTimeStrByTimeArr(timeArr) {
        var str = timeArr[0] + '年';
            str = str + this.getTimeStrByInt(timeArr[1]) + '月';
            str = str + this.getTimeStrByInt(timeArr[2]) + '日';
            str = str + this.getTimeStrByInt(timeArr[3]) + ':';
            str = str + this.getTimeStrByInt(timeArr[4]);
        return str;
    },
    getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return decodeURI(r[2]);
        };
        return null;
    },
    // 获取名字的首字母
    getFirstLetterByName(name) {
        var firstL = name.spell().slice(0, 1);
        // console.log('firstL-----', name, firstL)
        if(/^[a-zA-Z]+$/.test(firstL)){
            // 字母开头命名
            firstL = firstL.toUpperCase();
        }else{
            // 非字母开头命名
            firstL = '#';
        }
        return firstL;
    },
    // 校验是否是正确手机号码
    isPoneAvailable(number) {
        var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!myreg.test(number)) {
            return false;
        } else {
            return true;
        }
    },
    // 检验是否是正确的邮箱地址
    isEmailAvailable(emailUrl) {
        var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
        if (!reg.test(emailUrl)) {
            return false;
        } else {
            return true;
        }
    },
    // 数组去重
    distinct(arr) {
        var result = [];
        var obj = {};
    
        for (var i of arr) {
            if (!obj[i]) {
                result.push(i);
                obj[i] = 1;
            }
        }
        return result;
    },
    // 在数组中查找是否有某对象
    checkArrayInArray(origiArr, arr) {
        for(var i = 0; i < origiArr.length; i++){
            if(origiArr[i][0] == arr[0]){
                return true;
            }
        }
        return false;
    },
    // 在数组中获取某个数组的index值
    getArrayIndexInArray(origiArr, arr) {
        for(var i = 0; i < origiArr.length; i++){
            if(origiArr[i][0] == arr[0]){
                return i;
            }
        }
        return -1;
    },
    // 在对象数组里取包含特定id的object的index
    getIdIndexInObjectArray(objectArr, id) {
        return _.findIndex(objectArr, function(o) { return o.id == id; });
        // for(var object of objectArr){
        //     var index = objectArr.indexOf(object);
        //     if(object.id == id){
        //         return index;
        //     }
        // }
        // return -1;
    },
    // 在字符串对象里获取某个存在目标字符的字符串的索引值
    getTextIndexInStringArray(arr, text) {
        for(var i = 0; i < arr.length; i++){
            if(arr[i].indexOf(text) != -1){
                return i;
            }
        }
    },
    /**
     * 获得指定数组的特定组合
     * @param {目标数组} targetArr 
     * @param {组合个数} num 
     */
    getCombineArrayByNum(targetArr, num) {
        if(!targetArr || !targetArr.length) {
            return [];
        }
    
        var len = targetArr.length;
        var resultArrs = [];
    
        // 所有组合
        var flagArrs = this.getFlagArrs(len, num);
        while(flagArrs.length) {
            var flagArr = flagArrs.shift();
            var combArr = [];
            for(var i = 0; i < len; i++) {
                flagArr[i] && combArr.push(targetArr[i]);
            }
            resultArrs.push(combArr);
        }
        return resultArrs;
    },
    /**
     * 获得从m中取n的所有组合
     */
    getFlagArrs(m, n) {

        if(!n || n < 1) {
            return [];
        }
    
        var resultArrs = [],
            flagArr = [],
            isEnd = false,
            i, j, leftCnt;
    
        for (i = 0; i < m; i++) {
            flagArr[i] = i < n ? 1 : 0;
        }
        resultArrs.push(flagArr.concat());
    
        while (!isEnd) {
            leftCnt = 0;
            for (i = 0; i < m - 1; i++) {
                if (flagArr[i] == 1 && flagArr[i+1] == 0) {
                    for(j = 0; j < i; j++) {
                        flagArr[j] = j < leftCnt ? 1 : 0;
                    }
                    flagArr[i] = 0;
                    flagArr[i+1] = 1;
                    var aTmp = flagArr.concat();
                    resultArrs.push(aTmp);
                    if(aTmp.slice(-n).join("").indexOf('0') == -1) {
                        isEnd = true;
                    }
                    break;
                }
                flagArr[i] == 1 && leftCnt++;
            }
        }
        return resultArrs;
    },
    /**
     * 给年补齐4位数
     * @param {年} $yy 
     */
    formatYearNum: function ($yy) {
        var $num = 4 - $yy.toString().length;
        for(var $i = 0; $i < $num; $i++){
            $yy = '0' + $yy;
        }
        return $yy;
    },
    /**
     * 检查时间间隔的分数
     * @param {时间戳} time 
     */
    checkTimeDiffMinuteToNow: function (time) {
        var nowDate = new Date(),
            nowTime = nowDate.getTime(),
            curTime = time*1000;
        var diffM = parseInt((nowTime-curTime)/1000/60);
        return diffM;
    },
    /**
     * 通过文本获得换行符
     * @param {文本} text 
     */
    getBreakLineByText(text) {
        if(!text) { return '' };
        var regex = /\n/gi;
        var newText = text.replace(regex, '<br />');
        newText = newText.replace(/<br \/><br \/>/gi, '<br />'); //删除多行
        newText = newText.replace(/<br \/><br \/>/gi, '<br />'); //删除多行
        return newText;
    },
    /**
     * 通过文本获得换行符
     * @param {文本} text 
     */
    getBreakLineTwoByText(text) {
        if(!text) { return '' };
        var regex = /\n/gi;
        var newText = text.replace(regex, '<br />');
        return newText;
    },
    /**
     * 获取文本内的年份数据
     * @param {文本} text 
     */
    getDiscussContentYear(text) {
        if(!text) { return '' };
        var regex = /\d{2,4}/gi;
        var numArr = text.match(regex);
        var newText = text;
        _.each(numArr, (num => {
            newText = text.replace(num, '<span onclick=clickNum('+num+')>'+num+'</span>');
        }))
        // console.error('getDiscussContentYear------', regex, numArr, newText);
        return newText;
    },
    /**
     * 获取批盘文本内的微信公众号等的内容
     * @param {文本} text 
     */
    getCommentWechatUrl(text) {
        var wechatUrl = '', textArr = text.split('<br />'), 
            resultText = '', resultTextArr = [];
        if(text.indexOf('微信公众号') != -1 && text.indexOf('链接') != -1 && text.indexOf('http') != -1) {
            wechatUrl = UTILS.getWechatUrlByText(text);
            for(var i = 0; i < textArr.length; i++) {
                if(textArr[i].indexOf('微信公众号') != -1 && textArr[i].indexOf('（') != -1 && textArr[i].indexOf('）') != -1) {
                    var tempText = textArr[i].replace("（", "：<span onclick=clickWechatUrl('"+wechatUrl+"')>");
                    tempText = tempText.replace('）', '</span>');
                    resultTextArr.push(tempText);
                }else {
                    if(textArr[i].indexOf('链接') == -1) {
                        resultTextArr.push(textArr[i]);
                    }
                }
            }
        }else{
            resultTextArr = textArr;
        }
        resultText = resultTextArr.length > 0 ? resultTextArr.join('<br />') : resultText;
        // console.error('getCommentWechatUrl-----', resultText);
        return resultText;
    },
    getReportCharacter(text) {
        let newText = text;
        if(newText.indexOf('外在性格：') != -1) {
            newText = newText.replace('外在性格：', '<span class="green-title">外在性格</span>')
        }
        if(newText.indexOf('内在性格：') != -1) {
            newText = newText.replace('内在性格：', '<span class="green-title">内在性格</span>')
        }
        return newText;
    },
    /**
     * 获取微信公众号链接
     * @param {文本} text 
     */
    getWechatUrlByText(text) {
        var startIndex = text.indexOf('http'),
            newText = text.slice(startIndex),
            endIndex = newText.indexOf('）');
        var resultText = endIndex != -1 ? newText.slice(0, endIndex) : '';
        return resultText;
    },
    /**
     * 检测标签id是否完全相等
     * @param {a标签} aLabel 
     * @param {b标签} bLabel 
     */
    getLabelStringEqual(aLabel, bLabel) {
        var aArr = [], bArr = [];
        if(aLabel && aLabel != '') {
            aArr = aLabel.split(',');
            aArr = aArr.sort((a, b) => a - b);
            aLabel = aArr.join(',');
        }
        if(bLabel && bLabel != '') {
            bArr = bLabel.split(',');
            bArr = bArr.sort((a, b) => a - b);
            bLabel = bArr.join(',');
        }
        return aLabel.indexOf(bLabel) != -1;
    },
    getLabelStringIncludeLabel(aLabel, bLabel) {
        var aArr = aLabel && aLabel != '' ? aLabel.split(',') : [], 
            bArr = bLabel && bLabel != '' ? bLabel.split(',') : [];
        if(aArr.length == 0 || bArr.length == 0) { return; }
        // console.error('------', aArr, bArr)
        for(var i = 0; i < aArr.length; i++) {
            if(bArr.indexOf(aArr[i]) != -1) {
                return true;
            }
        }
        return false;
    },
    /**
     * 根据时间字符串获取时间信息
     * N<1分钟即在1分钟内不包含1分钟N显示为：刚刚
     * 1分钟=<N<1小时内不包含1小时显示：N分钟前
     * 1小时=<N<24小时，则显示具体发布时间N1:N2 (指N1点N2分)
     * 24小时=<N<7天内包括7天显示天数，小时数除以24小时取整数为N，显示：N天前
     * N>7天显示：日期，当年内的不用显示年，只显示N1月N2日；今年以外的才显示N1年N2月N3日
     * @param {时间字符串} timeStr 
     */
    getTimeInfoByTimeString(timeStr) {
        var resultStr = '',
            nowDate = MOMENT_TIME.getUnixTimeByTimeStr(),
            nowArr = MOMENT_TIME.getTimeArrayByTimeStamp(),
            timeDate = MOMENT_TIME.getUnixTimeByTimeStr(timeStr),
            timeArr = MOMENT_TIME.getTimeArrayByTimeStamp(timeDate*1000),
            diffTime = nowDate - timeDate,
            diffDay = parseFloat(diffTime/(3600 * 24)), 
            diffHour = parseFloat(diffTime/3600), 
            diffMinute = parseInt(diffTime/60);
        if(diffDay > 0 && diffDay < 1) {
            if(diffHour >= 1) {
                resultStr = UTILS.getTimeStrByInt(timeArr[3])+':'+UTILS.getTimeStrByInt(timeArr[4]);
            }else if(diffMinute >= 1 && diffMinute < 60) {
                resultStr = diffMinute+'分钟前';
            }else if(diffMinute < 1) {
                resultStr = '刚刚';
            }
        }else if(diffDay >= 1 && diffDay <= 7) {
            resultStr = parseInt(diffDay)+'天前';
        }else if(diffDay > 7) {
            if(nowArr[0] != timeArr[0]) {
                resultStr = UTILS.getTimeStrByInt(timeArr[0])+'年'+UTILS.getTimeStrByInt(timeArr[1])+'月'+UTILS.getTimeStrByInt(timeArr[2])+'日';
            }else {
                resultStr = UTILS.getTimeStrByInt(timeArr[1])+'月'+UTILS.getTimeStrByInt(timeArr[2])+'日';
            }
        }
        return resultStr;
    },
    /**
     * 根据时间戳获取时间信息
     * N<1分钟即在1分钟内不包含1分钟N显示为：刚刚
     * 1分钟=<N<1小时内不包含1小时显示：N分钟前
     * 1小时=<N<24小时，则显示具体发布时间N1:N2 (指N1点N2分)
     * 24小时=<N<7天内包括7天显示天数，小时数除以24小时取整数为N，显示：N天前
     * N>7天显示：日期，当年内的不用显示年，只显示N1月N2日；今年以外的才显示N1年N2月N3日
     * @param {时间戳} timeStamp 
     */
    getTimeInfoByTimeStamp(timeStamp) {
        var resultStr = '',
            nowDate = MOMENT_TIME.getUnixTimeByTimeStr(),
            nowArr = MOMENT_TIME.getTimeArrayByTimeStamp(),
            timeArr = MOMENT_TIME.getTimeArrayByTimeStamp(timeStamp*1000),
            diffTime = nowDate - timeStamp,
            diffDay = parseFloat(diffTime/(3600 * 24)), 
            diffHour = parseFloat(diffTime/3600), 
            diffMinute = parseInt(diffTime/60);
        if(diffDay > 0 && diffDay < 1) {
            if(diffHour >= 1) {
                resultStr = UTILS.getTimeStrByInt(timeArr[3])+':'+UTILS.getTimeStrByInt(timeArr[4]);
            }else if(diffMinute >= 1 && diffMinute < 60) {
                resultStr = diffMinute+'分钟前';
            }else if(diffMinute < 1) {
                resultStr = '刚刚';
            }
        }else if(diffDay >= 1) {
            if(nowArr[0] != timeArr[0]) {
                resultStr = UTILS.getTimeStrByInt(timeArr[0])+'年'+UTILS.getTimeStrByInt(timeArr[1])+'月'+UTILS.getTimeStrByInt(timeArr[2])+'日';
            }else {
                resultStr = UTILS.getTimeStrByInt(timeArr[1])+'月'+UTILS.getTimeStrByInt(timeArr[2])+'日';
            }
            resultStr = resultStr + ' ' + UTILS.getTimeStrByInt(timeArr[3])+':'+UTILS.getTimeStrByInt(timeArr[4]);
        }
        // console.log('getTimeInfoByTimeStamp------', diffMinute, resultStr);
        return resultStr;
    },
    /**
     * 复制文本到剪切板s
     * @param {文本} text 
     * @param {复制成功后回调函数} cb 
     */
    copyTextToClipboard(text, cb) {
        const input = document.createElement('input');
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('value', text);
        document.body.appendChild(input);
        input.select();
        input.setSelectionRange(0, 9999);
        var me = this;
        setTimeout(() => {
            if (document.execCommand('copy')) {
                document.execCommand('copy');
                console.log('复制成功');
                if(cb && typeof(cb) == 'function') {
                    cb();
                }
            }
            document.body.removeChild(input);
        }, 20);
    },
    /**
     * url地址转换
     */
    getQQUrlByCurrentPath(curPathname) {
        var newUrl = CONFIG.qq_url;
        if(curPathname != '/') {
            curPathname = curPathname.replace('/', '?path=');
            curPathname = curPathname.replace(/\//g, '-')
            newUrl = newUrl + curPathname;
        }
        console.log('getQQUrlByCurrentUrl--------', curPathname, newUrl)
        return newUrl;
    },
    getWechatUrlByCurrentPath(curPathname) {
        var newUrl = CONFIG.wechat_url;
        if(!curPathname) { return newUrl; }
        if(curPathname.indexOf('share-detail') != -1) {
            curPathname = curPathname.replace('-', '/');
            curPathname = curPathname.replace('-', '/');
        }else {
            curPathname = curPathname.replace(/-/g, '/');
        }
        newUrl = newUrl + curPathname;
        console.error('getWechatUrlByCurrentPath------', newUrl)
        return newUrl;
    },
    /**
     * 获取逆时针数组:雷达图用
     */
    getAnticlockwiseArray(arr) {
        var newArr = arr.slice(1);
            newArr = newArr.reverse();
            newArr.splice(0, 0, arr[0]);
        // console.log('getAnticlockwiseArray----', arr, arr[0], newArr)
        return newArr;
    },
    /**
     * 根据用户id获取头像地址
     * @param {用户id} uid 
     */
    getAvatarUrlByUid(uid) {
        var baseUrl = 'https://api.yxdxt.com/profile/?id=';
        var timeArr = MOMENT_TIME.getTimeArrayByTimeStamp().splice(0, 4),
            timeStr = timeArr.join('');
        return baseUrl+uid+'&x-oss-process=image/resize,h_200,w_200&v='+timeStr;
    },
    /**
     * 获取列表里的id拼接字段
     * @param {列表} list 
     */
    getIdListStrByArray(list) {
        var resultStr = '';
        list.forEach(lData => { resultStr = resultStr+(lData.id+',') });
        resultStr = resultStr.charAt(resultStr.length-1) == ',' ? resultStr.slice(0, -1) : resultStr;
        return resultStr;
    },
    /**
	 * 获取随机数
	 * @param {Object} max
	 */
	getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max));
    },
    /**
     * 比较版本号是否新版本
     * @param {比较的版本号} verComp 
     * @param {被比较的版本号} verCur 
     * @returns 
     */
    compareNewerVersion(verComp, verCur) {
        let arrComp = verComp.split('.'),
            arrCur = verCur.split('.');
        let isNewVer;
        for(let i = 0; i < arrComp.length; i++) {
            isNewVer = isNewVer == undefined ? parseInt(arrCur[i]) >= parseInt(arrComp[i]) : isNewVer && parseInt(arrCur[i]) >= parseInt(arrComp[i]);
        }
        return isNewVer;
    },
    /**
     * 获取倒计时格式化时间
     * @param {时间秒} time 
     * @returns 
     */
    getCountDownTimeStr(time, type) {
        let minute = parseInt(time/60);
        let second = time%60;
        let ret = '';
        if(type == 1) {
            ret = UTILS.getTimeStrByInt(minute)+':'+UTILS.getTimeStrByInt(second);
        }else if(type == 2) {
            ret = UTILS.getTimeStrByInt(minute)+'分'+UTILS.getTimeStrByInt(second)+'秒';
        }
        return ret;
    },
    /**
     * 根据时间获取倒计时信息0天00:00:00
     * @param {时间} time 
     * @returns 
     */
    getDayHourMiSTimeByTime(time) {
        let day = UTILS.getTimeStrByInt(parseInt(time/3600/24));
        let hour = UTILS.getTimeStrByInt(parseInt((time-day*3600*24)/3600));
        let minute = UTILS.getTimeStrByInt(parseInt((time-day*3600*24-hour*3600)/60));
        let second = UTILS.getTimeStrByInt(time-day*3600*24-hour*3600-minute*60);
        return {
            day: day,
            hms: [hour, minute, second]
        }
    },

    /**
     * 将params对象转换成URL拼接参数
     * @param {Object} params 
     * @returns {String} URL拼接参数
     */
    convertParamsToUrl(params) {
        return Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
    },
    /**
     * 获取五行文本
     * @param index 
     * @returns 
     */
    getWxTextByIndex(index) {
        return consts.CONST_WU_XING_TEXT[index];
    },
    /**
     * 获取五行样式
     * @param index 
     * @returns 
     */
    getWxClassByIndex(index) {
        return consts.CONST_WU_XING_CLASS[index];
    },
    /**
     * 获取干支信息
     * @param tgArr 
     * @param dzArr 
     * @returns 
     */
    getGzYMDByArr(tgArr, dzArr) {
        return {
            year: consts.CONST_TIAN_GAN.charAt(tgArr[0])+consts.CONST_DI_ZHI.charAt(dzArr[0])+'年',
            month: consts.CONST_TIAN_GAN.charAt(tgArr[1])+consts.CONST_DI_ZHI.charAt(dzArr[1])+'月',
            day: consts.CONST_TIAN_GAN.charAt(tgArr[2])+consts.CONST_DI_ZHI.charAt(dzArr[2])+'日',
        }
    },
    /**
     * 获取周几
     * @param day 
     * @returns 
     */
    getWeekTextByDay(day) {
        return consts.CONST_WEEK_WORD[day];
    },
    /**
     * 获取颜色数组信息
     * @param rankArr 
     */
    getColorArrByArr(rankArr) {
        let retArr = [];
        rankArr.forEach((el, index) => {
            retArr.push(Object.assign(el, {
                colorClass: consts.CONST_COLOR_CLASS[el.wx-1],
                colorText: el.colour.join('、'),
                rankText: consts.CONST_RANK_TEXT[index]
            }))
        });
        return retArr;
    },
    /**
     * 获取时间
     * @param date 
     * @param day 
     * @returns 
     */
    getNextDate(date, day) {
        var dd = new Date(date.getTime());
            dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return new Date(y + "-" + m + "-" + d);
    }

}

export {
    UTILS, LS, UA, FORM, MIX, SCHEME, COOKIE
}